import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Auth } from '@angular/fire/auth';
import { TranslateService } from '@ngx-translate/core';

import { SocialSigninService } from '../../social-signin/social-signin.service';
import { ToastService } from '../../toast/toast';

@Component({
    standalone: false,
    selector: 'abs-verify-email',
    template: `
        <abs-page-layout [pageTitle]="'GLOBAL.LOGIN.VERIFY_EMAIL.TITLE' | translate">
            <div class="content">
                <p>{{ 'GLOBAL.LOGIN.VERIFY_EMAIL.MESSAGE' | translate }}</p>
                <div class="buttons">
                    <ion-button (click)="resend()" [disabled]="resendDisabled">
                        {{ 'GLOBAL.LOGIN.VERIFY_EMAIL.RESEND' | translate }}
                    </ion-button>
                </div>
            </div>
        </abs-page-layout>
    `
})
export class VerifyEmailPage implements OnInit, OnDestroy {
    resendDisabled = false;
    private pollHandle: any;
    private resendTimeoutHandle: any;
    private destroyed = false;

    constructor(
        private socialSignin: SocialSigninService,
        private router: Router,
        private auth: Auth,
        private toast: ToastService,
        private translateService: TranslateService
    ) {}

    ngOnInit() {
        this.startPolling();
    }

    ngOnDestroy() {
        this.destroyed = true;
        if (this.pollHandle) {
            clearInterval(this.pollHandle);
        }
        if (this.resendTimeoutHandle) {
            clearTimeout(this.resendTimeoutHandle);
        }
    }

    startPolling() {
        this.pollHandle = setInterval(async () => {
            const user = this.auth.currentUser;
            if (!user) {
                return;
            }
            await user.reload();
            if (this.destroyed) {
                return;
            }
            if (user.emailVerified) {
                clearInterval(this.pollHandle);
                this.router.navigate(['/']);
            }
        }, 3000);
    }

    async resend() {
        const user = this.auth.currentUser;
        if (!user) {
            return;
        }

        try {
            await this.socialSignin.sendVerificationEmail(user);
        } catch (err: any) {
            if (!this.destroyed) {
                this.toast.showToast('', this.translateService.instant('GLOBAL.ERRORS.' + (err.code || 'UNKNOWN')), {
                    color: 'danger',
                    duration: 3000
                });
            }
            return;
        }

        if (this.destroyed) {
            return;
        }

        this.toast.showToast('', this.translateService.instant('GLOBAL.LOGIN.VERIFY_EMAIL.RESENT'), {
            color: 'success',
            duration: 3000
        });
        this.resendDisabled = true;
        this.resendTimeoutHandle = setTimeout(() => {
            this.resendDisabled = false;
        }, 60000);
    }
}
